import { api, apiFormData } from "api/loginRoutes";
import { createAction } from "./defaults";
import { PROTECTED_RANGES as PREFIX } from "const";
import { PROTECTED_RANGES_SET_LOADING, PROTECTED_RANGES_SET_LIST } from "./actionTypes";
import {
    PROTECTED_RANGES_GET_LIST_API,
    PROTECTED_RANGES_REMOVE_LIST_API,
    PROTECTED_RANGES_UPLOAD_API,
    SMS_PROTECTED_RANGES_GET_LIST_API,
    SMS_PROTECTED_RANGES_REMOVE_LIST_API,
    SMS_PROTECTED_RANGES_UPLOAD_API,
    SMS_PROTECTED_RANGES_CREATE_TEXT_API
} from "const/apiMethods";
import { servicePick } from "utils";


const setLoading = createAction(PROTECTED_RANGES_SET_LOADING);
const setProtectedRangesList = createAction(PROTECTED_RANGES_SET_LIST);

export const setProtectedRangesLoading = (value) => (dispatch) => {
    dispatch(setLoading(value));
};

export const getProtectedRangesList = (filter, service) => async (dispatch) => {
    dispatch(setLoading(true));

    const method = servicePick(service, PROTECTED_RANGES_GET_LIST_API, SMS_PROTECTED_RANGES_GET_LIST_API);

    return await api(method, { filter })
        .then((response) => {

            dispatch(setProtectedRangesList({
                list: response.price_range_protected_list,
                // count: response.price_range_protected_count,
                // page,
                // perPage
            }));
        })
        .finally(() => dispatch(setLoading(false)));
};

export const removeProtectedRangesList = (keyList, service) => (dispatch) => {
    const method = servicePick(service, PROTECTED_RANGES_REMOVE_LIST_API, SMS_PROTECTED_RANGES_REMOVE_LIST_API);
    return api(method, { prp_key_list: keyList });
};

export const uploadProtectedRangesFile = (params, service) => (dispatch) => {
    const method = servicePick(service, PROTECTED_RANGES_UPLOAD_API, SMS_PROTECTED_RANGES_UPLOAD_API);
    return apiFormData(method, params);
};